import { TFunction } from 'i18next';
import { apiClientWithoutHandler } from 'src/js/api';
import { APIPath } from 'src/js/api/route-path-index';
import { createWatchStore, updateWatchStore } from 'src/js/store/use-watch';
import { AuditModel } from './audit-models';

const auditModel: AuditModel = {
  state: '',
};

createWatchStore(auditModel);
export default auditModel;

export const saveResponseToAudit = (response: AuditModel) => {
  //console.log('before, after', presets, response)
  updateWatchStore(auditModel, response);
};

export const fetchAudit = (_t: TFunction) => {
  // console.log('fetch presets')
  //
  return apiClientWithoutHandler.genericController.get(APIPath.audit).then((res: any) => {
    const response = res.data;
    if (response) {
      saveResponseToAudit(response);
    }
    return res;
  });
};
